import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const TaxDetailsTableWrapper = styled.div`
  .tax-configuration-middle {
    margin: 24px 0px;
    ${responsive.MOBILE`
      margin: 16px 0;
    `}
  }

  .tax-configuration-add-button {
    margin-top: 24px;
    justify-content: flex-end;
    display: flex;
    ${responsive.MOBILE`
      margin-top: 16px;
      button {
        width:100%;
      }
    `}
  }

  .MuiGrid2-root {
    padding-right: 0px;
  }

  .tax-configuration-total-amount-percentage-container {
    display: flex;
    align-items: center;
  }

  .tax-configuration-total-amount-percentage {
    padding: 4px 10px;
    margin-left: 8px;
    background-color: ${COLORS.cirrus_black2};
    border-radius: 4px;
  }

  .tax-configuration-table {
    margin-top: 20px;
  }
`;
